import { inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/abstract-classes/api.service/api.service';
import { EngravingType } from 'src/app/interfaces/engraving-type';
import { EngravingTypesProviderService } from 'src/app/providers/engraving-types/engraving-types.provider.service';

@Injectable({
  providedIn: 'root'
})
export class EngravingTypesService extends ApiService<EngravingType, EngravingTypesProviderService> {
  private engravingTypesProviderService = inject(EngravingTypesProviderService);
  protected override get provider(): EngravingTypesProviderService {
    return this.engravingTypesProviderService;
  }
}
